import ConfirmRegister from './ConfirmRegister';
export default ConfirmRegister;